import { Layer } from './layer';

import ImageWMS from 'ol/source/ImageWMS';
import ImageLayer from 'ol/layer/Image';

import { TIME_RANGE, DiscreteRange, LinearRange } from './time/time';

const LEGEND_SIZE_KEY = 'LEGEND_SIZE';

class WMSLayer extends Layer {
	
	constructor(source, layer) {
		super(layer);
		this.source = source;
		this.extent = undefined;
				
		this.source.on('imageloadstart', ({image}) => {
			if( image.extent ) {
				this.extent = image.extent;
			}
		})
	}
	
	updateLayers(layers) {
        this.source.updateParams({ 'LAYERS': layers });
    }
    
    updateStyles(styles) {
        const value = styles || '';
        this.source.updateParams({ 'STYLES': value });
        this.source.changed();
    }
    
    updateVersion(version) {
        this.source.updateParams({ 'VERSION': version});
    }
    
    updateCqlFilter(cqlFilter) {       
    	if( cqlFilter ) {
            this.source.updateParams({'CQL_FILTER': cqlFilter});        
        } else {
            const params = this.source.getParams();
            
            if( params.hasOwnProperty('CQL_FILTER') ) {
                delete params['CQL_FILTER'];
                this.source.changed();
            }
        }   
    }

  	updateTime(time) {
  		if( time ) {
            this.source.updateParams({'TIME': time});        
        } else {
            const params = this.source.getParams();
            
            if( params.hasOwnProperty('TIME') ) {
                delete params['TIME'];
                this.source.changed();
            }
        } 
  	}
  	
  	getTimestamp() {
		const params = this.source.getParams();       
      	return params['TIME'];
  	}
  	
  	setUrl(url) {
  		this.source.setUrl(url);
  	}
  	
  	getExtent() {
  		return this.extent;
  	}
  	
  	setLinearTimeRange(startOfRange, endOfRange) {
  		this.layer.set(TIME_RANGE, new LinearRange(startOfRange, endOfRange));  	
  	}
  	
  	setDiscreteTimeRange(records) {
  		this.layer.set(TIME_RANGE, new DiscreteRange(records));
  	}
  	
  	clearTimeRange() {
  		this.layer.set(TIME_RANGE, null);  	
  	}
  	
  	getLegendUrl(resolution) {
  		let url = super.getLegendUrl(resolution);
  		
  		const legendSize = this.layer.get(LEGEND_SIZE_KEY);
  		
  		if( url == null && legendSize != null ) { 
  			const { width, height } = legendSize
  			const params = this.source.getParams();
  					
  			const legendParams = {
  				HEIGHT: height,
            	WIDTH: width,
            	STYLE: params.STYLES || '',
            	TIME: params.TIME,
            	CQL_FILTER: params.CQL_FILTER
            }           		
  		
  			url = this.source.getLegendUrl( resolution, legendParams);             
  		}
  		
  		return url;
  	}
  	
  	setLegendSize(width, height) { 
  		const currentSize = this.layer.get(LEGEND_SIZE_KEY);  		
  		
  		if( !currentSize || currentSize.width !== width || currentSize.height !== height ) {
	  		this.layer.set(LEGEND_SIZE_KEY, {
	  			width: width,
	  			height: height
	  		});
  		}
  	}  	
  	
  	
  	setImageLoadFunction(loaderFunc) {
  	 	if( loaderFunc != null ) {  
  	 		// build a function that converts loader (img -> Promise<Blob>)
  	 		// to dataURL
  	 			 	
  	 		const imageLoader = (image, url) => {
  	 			loaderFunc(url)
  	 			.then(blob => { 	 				
  	 				const reader = new FileReader();
                 
        			reader.onload = () => {
        				image.getImage().src = reader.result;
        			}
        			
        			reader.readAsDataURL(blob);        			
    			})
        	};
        
            this.source.setImageLoadFunction(imageLoader);        
        }
  	}  	
  	
  	refresh() {
  		this.source.updateParams({'_cache': new Date().getTime()});
  	}
  	  	  	
  	getFeatureInfoUrl(coordinate, items, resolution, projection, contentType) {
  		return this.source.getFeatureInfoUrl(coordinate, resolution, projection, {
            info_format: contentType,
            feature_count: items
        });
  	}
	
}

const wms = (url, layers) => {    
    const source = new ImageWMS({
    	url: url,
        params: {'LAYERS': layers}
    });
    
    const layer = new ImageLayer({
    	source: source
    });
    
    return new WMSLayer(source, layer);
}

export { wms, WMSLayer, LEGEND_SIZE_KEY }